import { render } from "./ObjectNavLink.vue?vue&type=template&id=3abcb0b6"
import script from "./ObjectNavLink.vue?vue&type=script&lang=js"
export * from "./ObjectNavLink.vue?vue&type=script&lang=js"

import exportComponent from "/app/tmp/blackhall/V3/v2026.7.r0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__